import App from './CoreApp';

// We are no longer rendering the app directly from the core package.
// Instead, we export the main App component so that implementing apps
// like 'tutorsmart' can import and render it.
export default App;

// The following code, which was previously here, has been removed.
// The implementing app ('tutorsmart') is now responsible for this.
/*
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'katex/dist/katex.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
*/